import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { KpiService } from "../../kpi/kpi.service";
import { Title } from "@angular/platform-browser";
import * as _ from "lodash";

@Component({
  selector: "student-comp-table-fixed-col",
  templateUrl: "./student-comp-table-fixed-col.component.html",
  styleUrls: ["./student-comp-table-fixed-col.component.scss"],
})
export class StudentCompTableFixedColComponent implements OnInit {
  @Input() students;
  @Input() bodyRowHoveredIndex;
  @Input() schools;
  // for mobile devices, checkbox click was triggering (mouseover), causing the table body to highlight, but not highlighting the table fixed column
  // -> add hover colour whenever the row index == bodyRowHoveredIndex or fixedColRowHoveredIndex
  @Input() fixedColRowHoveredIndex;

  @Output() rowHoveredEvent = new EventEmitter<any>();
  @Output() studentSelected = new EventEmitter();
  schoolsForTable;

  partialImagePath: string = "../../assets/images/";

  constructor(private kpiService: KpiService, private titleService: Title) {}

  ngOnInit() {
    this.schoolsForTable = _.keyBy(this.schools, "systemSchoolId");
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  rowHovered(index) {
    this.rowHoveredEvent.emit(index);
  }

  getFormattedStudentName(firstName, lastName) {
    let studentName;
    if (
      (lastName === "" && firstName === "") ||
      (lastName === "-----" && firstName === "-----")
    ) {
      studentName = "(name not provided)";
    } else if (lastName === "-----") {
      studentName = firstName;
    } else if (firstName === "-----") {
      studentName = lastName;
    } else {
      studentName = lastName + ", " + firstName;
    }
    return studentName;
  }
}
